var React = require('react');

function File (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 0h8.5L14 2.5V15a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm10 3h-1.5c-.323 0-.5-.183-.5-.5V1H3v14h10V3z"}));
}

File.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = File;

File.default = File;
